export default {
  'footer.tagline':
    'Une seule plateforme. Un monde de possibilités. Connecter les talents, les opportunités et les entreprises pour bâtir un avenir sans limites.',
  'footer.ecosystem': 'Écosystème',
  'footer.information': 'Informations',
  'footer.contact': 'Contact',
  'footer.about': 'À propos',
  'footer.terms': "Conditions d'utilisation",
  'footer.privacy': 'Politique de confidentialité',
  'footer.legal': 'Mentions légales',
  'footer.careers': 'Carrières',
  'footer.email': 'contact@worldapeiron.com',
  'footer.phone': '+228 97 98 58 49',
  'footer.location': 'Lomé, Togo',
  'footer.rights': 'Tous droits réservés.',
};